import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Box, HStack, Image, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import IntegrationExternalIdStack from '../../../../../components/IntegrationExternalIdStack';
import { analyticsIds } from '../../../../../constants/analyticsIds';
import { getRowValue } from '../../../../../utils/tableUtil';

const ExternalIdCell = ({ row, value: insured }) => {
  const { url } = useRouteMatch();

  if (row.original.insuredIntegrations?.length) {
    return (
      <Box maxW="200px">
        <IntegrationExternalIdStack
          customExternalId={insured?.externalId}
          dataAnalyticsId={analyticsIds.reportsPage.insuredExternalIdLink}
          integrations={row?.original?.insuredIntegrations}
          linkUrl={url.replace(/reports.*/, `insureds/${insured.id}`)}
          resourceName="insuredId"
        />
      </Box>
    );
  }

  return (
    <Box maxW="200px">
      <Link
        data-analytics-id={analyticsIds.reportsPage.insuredExternalIdLink}
        rel="noopener noreferrer"
        target="_blank"
        title={insured.externalId}
        to={url.replace(/reports.*/, `insureds/${insured.id}`)}
      >
        {insured.externalId}
      </Link>
      <Text color="grey" textStyle="bodyXs">{getRowValue(row, 'insuredDescription')}</Text>
    </Box>
  );
};

ExternalIdCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      job: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      department: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
      insuredIntegrations: PropTypes.arrayOf(PropTypes.shape({
        externalId: PropTypes.string,
        integrationTypeName: PropTypes.string,
        thumbnailUrl: PropTypes.string,
        insuredId: PropTypes.number
      }))
    })
  }),
  value: PropTypes.shape({ insured: PropTypes.oneOfType([PropTypes.object, PropTypes.array]) })
};

export default ExternalIdCell;
